import React from "react";
import "./COALoadingPage.css";

export default function COALoadingPage({ page }) {
  return (
    <div className="COALoadingPage__Container">
      <div className="COALoadingPage__PlaceHolder">
        <div className="COALoadingPage__Content">
          <div className="COALoadingPage__Header">
            <div className="COALoadingPage__Search ActiveloadingAnimation" />
            {page !== "COAReport" && (<div className="COALoadingPage__CreateBtn ActiveloadingAnimation" />)}
          </div>
          <div className="COALoading ActiveloadingAnimation" />
        </div>
      </div>
    </div>
  );
}
